module.exports = (RESTService) ->
  'ngInject'
  {
    service: ->
      RESTService.service('admin/countries')
  }
